import React from 'react';
export function ModulesSection() {
  const modules = [{
    num: '01',
    title: 'Empezá bien con tu freidora',
    desc: 'Dominás los tiempos y temperaturas sin quemar nada'
  }, {
    num: '02',
    title: 'Recetas rápidas para el día a día',
    desc: 'Opciones listas en 15 minutos para cualquier día de semana'
  }, {
    num: '03',
    title: 'Almuerzos que te llenan',
    desc: 'Platos completos que no te dejan con hambre a las 3 de la tarde'
  }, {
    num: '04',
    title: 'Cenas livianas y rápidas',
    desc: 'Para cuando llegás cansada y no querés pensar nada'
  }, {
    num: '05',
    title: 'Fin de semana sin estrés',
    desc: 'Recetas un poco más elaboradas para cuando tenés ganas'
  }, {
    num: '06',
    title: 'Para picar sin culpa',
    desc: 'Snacks y entradas que impresionan y se hacen solos'
  }, {
    num: '07',
    title: 'Postres en air fryer',
    desc: 'Sí, también se pueden hacer postres. Y quedan increíbles.'
  }];
  return <section className="py-20 px-4 bg-brand-purpleLight" data-id="element-134">
      <div className="max-w-5xl mx-auto" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <div className="inline-flex bg-white text-brand-purpleDark px-4 py-1.5 rounded-full font-semibold text-sm mb-6 shadow-sm" data-id="element-137">
            Qué incluye
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-darkGray" data-id="element-138">
            7 módulos — cada uno resuelve un momento de tu semana
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-139">
          {modules.map((mod, index) => <div key={index} className={`bg-white p-6 rounded-2xl shadow-sm border border-brand-purple/10 flex flex-col ${index === 6 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-140">
              <div className="flex items-center gap-3 mb-2" data-id="element-141">
                <div className="text-brand-purple font-bold text-xl" data-id="element-142">
                  {mod.num}
                </div>
                <div className="text-gray-300 font-light" data-id="element-143">·</div>
                <h3 className="font-bold text-brand-darkGray text-lg" data-id="element-144">
                  {mod.title}
                </h3>
              </div>
              <p className="text-brand-mediumGray font-medium pl-10" data-id="element-145">
                {mod.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}